"use client"

import { useEffect, useState } from 'react'
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '../ui/alert-dialog'
import { FaPhoneAlt } from 'react-icons/fa'
import { XIcon } from 'lucide-react'
import GetInTouchForm from '../forms/get-in-touch-form'
import { cn } from '@/lib/utils'
import { buttonVariants } from '../ui/button'

export default function CustomHeroSectionFormButton({ destination }: { destination?: string }) {

    const [isOpen, setIsDialogOpen] = useState(false)
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsDialogOpen(true);
        }, 5555);

        return () => clearTimeout(timer);
    }, []);

    return (
        <AlertDialog open={isOpen} onOpenChange={setIsDialogOpen}>
            <AlertDialogTrigger>
                <button className="mt-4 mb-12 flex items-center gap-2 rounded-lg bg-teal-500 px-4 py-2.5 sm:px-6 sm:py-3 text-sm sm:text-base font-semibold text-white shadow-md transition hover:bg-teal-600">
                    <FaPhoneAlt />
                    Request a Callback
                </button>
            </AlertDialogTrigger>
            <AlertDialogContent className="pb-2">
                <AlertDialogHeader>
                    <div className="flex w-full items-start">
                        <AlertDialogTitle className="text-2xl font-semibold font-lexend">
                            Fill out the form and our team will contact you soon....
                        </AlertDialogTitle>
                        <button onClick={() => setIsDialogOpen(false)} className={cn(buttonVariants({ variant: "default" }), "hover:bg-custom-primary rounded shrink-0 size-8 absolute top-1 right-1")}>
                            <XIcon />
                        </button>
                    </div>
                    <AlertDialogDescription className="">
                        <div className="mx-auto w-full">
                            <GetInTouchForm destination={destination} note onSuccess={() => setIsDialogOpen(false)} />
                        </div>
                    </AlertDialogDescription>
                </AlertDialogHeader>
            </AlertDialogContent>
        </AlertDialog>
    )
}
